import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

import { setEulaHeaderHeight } from "../../../store/layout";
import { EulaBanner } from "../eulaBanner";

import "./EulaHeader.scss";

export const EulaHeader = () => {
  const dispatch = useDispatch();

  const handleHeightChange = useCallback(
    (height: number): void => {
      dispatch(setEulaHeaderHeight(height));
    },
    [dispatch]
  );

  return (
    <EulaBanner
      className="eula-header"
      contentId="eulaHeaderText"
      onHeightChange={handleHeightChange}
    />
  );
};
